import { createFileRoute } from '@tanstack/react-router';
import { InspectionPreparationPage } from '@/features/nis2/pages/InspectionPreparationPage';

export const Route = createFileRoute('/_authenticated/nis2/inspection-preparation/$preparationId')({
  component: InspectionPreparationPage,
});
